module.exports = __webpack_public_path__ + "img/note.0a16f4e4.jpg";